<template>
  <div id="CreateUserAdmin" class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="pageTitle">Upload</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-header">New staff upload</div>
          <div class="card-body">
            <div v-if="preview">
              <h1>Data Preview</h1>
              <p class="text-success">Total records: {{ staff.length }}</p>
              <p class="text-danger">Please verify the accuracy of the data, and then click the save button at the bottom.</p>
            </div>
            <p v-else class="text-danger">
              ONLY CSV IS ALLOWED. Please make sure it follows the screenshot's instructions for <b>column arrangement</b>.
              <!-- See
              <router-link :to="{ name: 'FacultiesAdmin' }">faculty ID and department ID</router-link> for reference. -->
            </p>

            <table class="table table-sm table-bordered monofont">
              <thead>
                <tr>
                  <th>Staff ID</th>
                  <th>name</th>
                  <th>email</th>
                  <th>mobile</th>
                  <!-- <th>facultyID</th>
                  <th>departmentID</th> -->
                  <th>gender</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(s, i) in staff" :key="i">
                  <td>{{ s.Matric }}</td>
                  <td>{{ s.Name }}</td>
                  <td>{{ s.Email }}</td>
                  <td>{{ s.Mobile }}</td>
                  <!-- <td>{{ s.FacultyID }}</td>
                  <td>{{ s.DepartmentID }}</td> -->
                  <td>{{ s.Gender }}</td>
                </tr>
              </tbody>
            </table>

            <p v-if="preview">
              <button @click="save" class="btn btn-danger btn-lg">Yes, save</button>
            </p>

            <!-- Dropzone -->
            <div class="form-group mt-5 mb-5" v-if="!preview">
              <b-icon-card-list></b-icon-card-list> <label for="att">upload csv file</label>
              <vue-dropzone
                id="dropzone"
                ref="myVueDropzone"
                :useCustomSlot="true"
                :options="dropzoneOptions"
                @vdropzone-error="uploadError"
                @vdropzone-success="uploadSuccess"
                @vdropzone-file-added="uploadFileAdded"
              >
                <div class="dropzone-custom-content" v-html="dropzoneOptions.myCustomContent"></div>
              </vue-dropzone>
            </div>
            <!-- Dropzone -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import router from '../../../router'
//import { required, email, numeric, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'StaffsUploadAdmin',

  data() {
    return {
      spinner: false,
      preview: false,
      fileName: '',
      staff: [],
      staffDefault: [
        {
          Matric: '123456...',
          Name: 'John...',
          Email: 'fut...@unilorin.edu.ng',
          Mobile: '0803...',
          /* FacultyID: 'ENG',
          DepartmentID: 'CPE', */
          Gender: 'M'
        },
        {
          Matric: '987654...',
          Name: 'Mary...',
          Email: 'mary...@unilorin.edu.ng',
          Mobile: '0706...',
          /* FacultyID: 'LAW',
          DepartmentID: 'CLW', */
          Gender: 'F'
        }
      ]
    }
  },

  mounted() {
    this.staff = this.staffDefault
  },

  methods: {
    uploadError(file) {
      this.spinner = false
      this.preview = false
      this.staff = this.staffDefault
      this.$swal('Oops!', file.fileName + ' not uploaded.', 'error')
    },

    uploadSuccess(file, response) {
      this.preview = true
      this.fileName = response.fileName
      this.staff = response.staff
      this.spinner = false
      //console.log(this.fileName)
      //console.log(this.staff)
    },

    uploadFileAdded(file) {
      this.spinner = true
    },

    save() {
      this.spinner = true
      axios
        .post(`/admin/staff-upload?fileName=${this.fileName}`)
        .then(res => {
          this.$swal('Success!', res.data.message, 'success')
          alert(res.data.message)
          console.log(res.data.numberOfFailed)
          window.location.reload()
        })
        .catch(error => {
          this.$swal('Oops!', 'Something went wrong.', 'error')
          window.location.reload()
        })
    }
  },

  computed: {
    dropzoneOptions() {
      return {
        thumbnailHeight: 80,
        maxFilesize: 2 ** 22, // 1073741824 bytes  1GB
        url: process.env.VUE_APP_API_URL + '/admin/staff-upload',
        headers: {
          apikey: process.env.VUE_APP_API_KEY,
          Authorization: 'Bearer ' + this.$store.state.authToken
        },
        acceptedFiles: 'text/csv',
        myCustomContent: '<span class="vdContent-title">Drag and drop to upload files here!</span>'
      }
    },

    client() {
      return this.$store.state.client
    }
  },

  components: {
    vueDropzone: vue2Dropzone
  }
}
</script>

<style scoped>
.monofont {
  font-family: 'Courier New', Courier, monospace;
  font-weight: bold;
  font-size: 0.85rem;
}
</style>
